import { useTranslation } from 'react-i18next';
import StandardPage from '@casops/templates/standard-page/StandardPage';
import { Outlet, useParams } from 'react-router-dom';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import { useMemo } from 'react';
import NavTabs from '@cas/components/tabs/nav-tabs/NavTabs';
import ConfigurationGroupHeader from './components/header/ConfigurationGroupHeader';

export function ConfigurationGroupPage() {
  const { t } = useTranslation();
  const { configGroupId } = useParams();

  // Convert route param string to id number.
  const modelId = typeof configGroupId !== 'undefined' ? Number(configGroupId) : undefined;

  const tabs = useMemo<NavTabModel[]>(() => {
    const configGroupPath = `/configuration/configuration-group/${modelId}`;

    return [
      {
        title: t('Navigation.Packages'),
        to: `${configGroupPath}/packages`,
      },
      {
        title: t('Navigation.Assets'),
        to: `${configGroupPath}/assets`,
      },
    ];
  }, [t, modelId]);

  return (
    <StandardPage header={<ConfigurationGroupHeader modelId={modelId} />}>
      <NavTabs tabs={tabs} hasBorder />
      <Outlet />
    </StandardPage>
  );
}

export default ConfigurationGroupPage;
